// 고객사 기준 정보(업무 통합 1단계) — 화면 공용 상수·순수 함수.
// 서버 정본: backend/services/work_customers.py(STATUSES·LOG_TYPES·KINDS) · routers/work_customers.py(list flags).
// 🔴 권한은 서버가 정본이다 — 화면은 응답의 can_edit·can_center_edit·editable_fields 로 단추만 정한다.

export const STATUS_OPTIONS = ['운영', '종료', '전체'];
export const STATUS_ENDED = '종료';
// 수기 이력 유형 7종(서버 LOG_TYPES 와 같은 값 · 상세 응답 log_types 가 있으면 그쪽을 쓴다).
export const LOG_TYPES = ['오출고', '오배송', '파손', '재고차이', '출고지연', '협의', '기타'];
// 기존/신규(서버 KINDS) — 빈 값은 «비움».
export const KIND_OPTIONS = ['기존', '신규'];
// 목록 빠른 필터 — 키는 목록 응답 items[].flags 의 키와 같다. 켠 것 모두 AND.
export const QUICK_FILTERS = [
  { key: 'no_staff', label: '센터담당 미지정' },
  { key: 'unmatched', label: '센터 미매칭' },
  { key: 'no_douzone', label: '더존 코드 없음' },
];
export const DASH = '—';

// 담당자 칸은 '/' 로 여러 명 — 앞뒤 공백을 지운 조각(빈 조각 제외).
export function splitNames(value) {
  return String(value || '').split('/').map((s) => s.trim()).filter(Boolean);
}

const lower = (v) => String(v == null ? '' : v).toLowerCase();

/**
 * 목록 화면 필터 — 서버는 status 만 거르고 나머지는 화면이 거른다.
 *  q = 업체명·센터담당 부분 일치(대소문자 무시) · center = centers[].perf_center 와 같은 행이 있음
 *  · ops = 운영 담당자(정)·(부) 이름 조각 중 하나 · sales = 영업 이름 조각 중 하나 · quick = 켠 빠른 필터 키 배열(모두 AND).
 */
export function filterCustomers(items, { q = '', center = '', ops = '', sales = '', quick = [] } = {}) {
  const list = Array.isArray(items) ? items : [];
  const needle = lower(q).trim();
  const keys = Array.isArray(quick) ? quick : [];
  return list.filter((it) => {
    if (!it) return false;
    if (needle && ![it.name, it.center_staff].some((v) => lower(v).includes(needle))) return false;
    if (center && !(Array.isArray(it.centers) ? it.centers : []).some((c) => c && c.perf_center === center)) return false;
    if (ops && ![...splitNames(it.ops_main), ...splitNames(it.ops_sub)].includes(ops)) return false;
    if (sales && !splitNames(it.sales).includes(sales)) return false;
    const flags = it.flags || {};
    if (keys.some((k) => !flags[k])) return false;
    return true;
  });
}

// 3200000 → '3,200,000원' (숫자가 아니면 0).
export function fmtWon(n) {
  const num = Number(n);
  const whole = Number.isFinite(num) ? Math.trunc(num) : 0;
  const sign = whole < 0 ? '-' : '';
  return `${sign}${String(Math.abs(whole)).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원`;
}

// 빈 값(null·undefined·공백뿐) → '—'.
export function dash(v) {
  if (v == null) return DASH;
  const text = String(v);
  return text.trim() ? text : DASH;
}

// 배상금액 입력칸 — 숫자·쉼표만 남긴다.
export function amountInput(text) {
  return String(text || '').replace(/[^\d,]/g, '');
}

// 배상금액 입력 → 정수 | null(비었으면).
export function parseAmount(text) {
  const digits = String(text || '').replace(/[^\d]/g, '');
  return digits ? Number(digits) : null;
}

// 오류 본문 {detail:{code,message}} 또는 문자열 detail → 화면 문구.
export function errorText(err, fallback) {
  const detail = err && err.response && err.response.data ? err.response.data.detail : null;
  if (detail && typeof detail === 'object' && typeof detail.message === 'string' && detail.message) return detail.message;
  if (typeof detail === 'string' && detail) return detail;
  return fallback;
}

// 409 stale — 다른 사람이 먼저 바꿨다(다시 읽어야 한다).
export function isStale(err) {
  const res = err && err.response;
  const detail = res && res.data ? res.data.detail : null;
  return !!res && res.status === 409 && !!detail && detail.code === 'stale';
}

export const statusOf = (err) => (err && err.response ? err.response.status : null);
